import { z } from 'zod';

// ────────────────────────────────────────────────────────────────────────────
// Server-shaped row (validated when consumed)
// ────────────────────────────────────────────────────────────────────────────

export const priceSeriesSchema = z.object({
  id: z.string(),
  apmcId: z.string(),
  apmcCode: z.string(),
  apmcName: z.string(),
  apmcDistrictName: z.string(),
  apmcStateName: z.string(),
  cropId: z.string(),
  cropCode: z.string(),
  cropName: z.string(),
  varietyId: z.string(),
  varietyCode: z.string(),
  varietyName: z.string(),
  isActive: z.boolean(),
  isManualMarketPrice: z.boolean(),
  runPredictionPipeline: z.boolean(),
  showPredictionInApp: z.boolean(),
  notes: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type PriceSeries = z.infer<typeof priceSeriesSchema>;

// ────────────────────────────────────────────────────────────────────────────
// Form schema — only the four toggles + notes are editable.
// ────────────────────────────────────────────────────────────────────────────

export const priceSeriesFormSchema = z.object({
  isActive: z.boolean(),
  isManualMarketPrice: z.boolean(),
  runPredictionPipeline: z.boolean(),
  showPredictionInApp: z.boolean(),
  notes: z.string().max(2000, 'Notes must be at most 2000 characters'),
});
export type PriceSeriesFormValues = z.infer<typeof priceSeriesFormSchema>;

// ────────────────────────────────────────────────────────────────────────────
// List filters
// ────────────────────────────────────────────────────────────────────────────

// Mirror of PriceSeriesSortKeyValues in the API.
export const PRICE_SERIES_SORT_KEYS = [
  'apmc',
  'crop',
  'variety',
  'updated',
] as const;
export type PriceSeriesSortKey = (typeof PRICE_SERIES_SORT_KEYS)[number];

export type SortDirection = 'asc' | 'desc';

export interface ListPriceSeriesParams {
  page: number;
  pageSize: number;
  searchText?: string;
  cropId?: number;
  apmcId?: number;
  varietyId?: number;
  // 'true' / 'false' / undefined — mirrors the API DTO.
  isActive?: 'true' | 'false';
  sortBy?: PriceSeriesSortKey;
  sortDir?: SortDirection;
}
